module.exports = __webpack_public_path__ + "notes-at-icon-512.png?c462dc7779f5ac8a30956e9ce25a728b";